import {
    disablePointersOnIframes,
    restorePointersOnIframes,
} from '../../services/styleFixer'
import {
    getFromExtLocalStorage,
    onExtLocalStorageChange,
    setToExtLocalStorage,
} from '../../services/extServices'
import { G_BTN_POSITION } from '../../background/constants'
import { logToAnalytics } from '../../background/services'
import { toggleLibrary } from './toggleLibrary'
import {
    QUICK_ACTION_ID,
    QUICK_ACTION_POPUP_ID,
} from '../../quickActions/quickActionDOM'

const DEFAULT_POSITION = '20vh'

export const onDragGbtn = ({ iframe, controlBtn, container, dragHandle }) => {
    if (EXT_MODE) {
        getFromExtLocalStorage([G_BTN_POSITION], result => {
            const initialPosition = result[G_BTN_POSITION]

            if (initialPosition) {
                // Compatibility with an old pixel approach - reset to default state
                if (initialPosition.endsWith('px')) {
                    controlBtn.style.bottom = DEFAULT_POSITION
                    setToExtLocalStorage(G_BTN_POSITION, DEFAULT_POSITION)
                } else {
                    controlBtn.style.bottom = initialPosition
                }
            }
        })

        onExtLocalStorageChange(G_BTN_POSITION, newValue => {
            controlBtn.style.bottom = newValue
        })
    }

    dragHandle.addEventListener('mousedown', e => {
        disablePointersOnIframes()

        /**
       * When we drag the SDK button - we want to avoid that the button will "run" out of the
       * viewport. Therefore, the calculations should be the following:
       *
       * 1. if delta < 0 - it means that we moved the button out of the viewport - and we want to position it at the
          bottom of the viewport
         2.delta > iframeSize.height - if we moved the button outside of the viewport from the top
           we position it at the top (we need to consider the button height)
       */
        let mouseDownY = e.clientY
        const iframeSize = iframe.getBoundingClientRect()

        const moveTo = pageY => {
            /**
             * The delta is calculated by the iframe size (the page's vertical size)
             *  - mouse position - 20 (the height of the button) - in order to center to button to the mouse pointer.
             */
            const moveDelta = iframeSize.height - pageY - 20
            if (moveDelta < 0) {
                controlBtn.style.bottom = '0vh' // Max bottom position
            } else if (moveDelta > iframeSize.height - 40) {
                controlBtn.style.bottom = 'calc(100vh - 40px)' // Max top position
            } else {
                controlBtn.style.bottom = `${
                    (100 * moveDelta) / iframeSize.height
                }vh`
            }
        }

        const onMouseMove = e => {
            moveTo(e.clientY)
        }

        const onMouseUp = e => {
            const dragDelta = Math.abs(e.clientY - mouseDownY)

            if (EXT_MODE) {
                setToExtLocalStorage(G_BTN_POSITION, controlBtn.style.bottom)
            }

            // ONCLICK: If button was dragged insignificantly, consider it a click
            if (dragDelta < 20) {
                toggleLibrary(container, iframe)

                if (EXT_MODE) {
                    logToAnalytics('guidde_button_clicked')
                }

                // SDK parent doesn't have token and can not send requests, so we proxy command to the iframe
                if (SDK_MODE) {
                    iframe.contentWindow?.postMessage(
                        { type: 'G_BTN_CLICKED' },
                        iframe.src
                    )
                }
            }

            document.removeEventListener('mousemove', onMouseMove)
            document.removeEventListener('mouseup', onMouseUp)
            restorePointersOnIframes()
        }

        document.addEventListener('mousemove', onMouseMove)
        document.addEventListener('mouseup', onMouseUp)
    })

    /**
     * Since the calculation of the button position when we drag it is from the bottom, we need to
     * calculate the page's vertical size and the button's location relative to it.
     */
    window.addEventListener('resize', () => {
        const bounds = controlBtn.getBoundingClientRect()
        const iframeSize = iframe.getBoundingClientRect()
        if (bounds.top < 0) {
            controlBtn.style.bottom = iframeSize.height - 40 + 'px'
        }
    })

    /* Click away listener
     *
     * It's established only for extension.
     * In SDK we have guidde.open() and guidde.close() which won't work when there's click away.
     */
    if (EXT_MODE) {
        document.addEventListener('click', event => {
            if (!event.target) return
            const isClickInside = container.contains(event.target as Node)

            const target = event.target as HTMLElement
            const isGuiddeClick =
                target.id === QUICK_ACTION_ID ||
                target.id === QUICK_ACTION_POPUP_ID

            if (!isClickInside && !isGuiddeClick) {
                iframe?.contentWindow?.postMessage(
                    { type: 'ON_CLICK_AWAY' },
                    iframe.src
                )
            }
        })
    }
}
